import { render } from "./infoDetails.vue?vue&type=template&id=7228da68&scoped=true"
import script from "./infoDetails.vue?vue&type=script&lang=js"
export * from "./infoDetails.vue?vue&type=script&lang=js"

import "./infoDetails.vue?vue&type=style&index=0&id=7228da68&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7228da68"]])

export default __exports__